// extracted by mini-css-extract-plugin
module.exports = {"container":"JobApplyGroupTop_container__3Jrpz","company":"JobApplyGroupTop_company__G0xRt","buttons":"JobApplyGroupTop_buttons__1aw0F","sending":"JobApplyGroupTop_sending__1QrLl"};